const GeneralLedger = require('./GeneralLedger').default;

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.web.generalLedger', deps)
  .directive('generalLedger', reactDirective =>
    reactDirective(
      GeneralLedger,
      ['clientId', 'dateRange', 'filters', 'setLocationParams', 'sidebarDescriptor', 'userId'],
      {},
      {},
    ),
  );
